<template>
    <div>
        <v-menu
            open-on-hover
            bottom
            offset-y
        >
            <template v-slot:activator="{ on, attrs }">
                <v-badge
                    color="red"
                    overlap
                    bordered
                >
                    <template v-slot:badge>
                        <strong>{{ display.size }}</strong>
                    </template>
                    <v-btn
                        depressed
                        class="ml-2 white--text"
                        color="blue darken-2"
                        small
                        v-bind="attrs"
                        v-on="on"
                        @click="click"
                    >
                        {{ $t('common.filter') }}
                        <v-icon right dark>mdi-filter-plus-outline</v-icon>
                    </v-btn>
                </v-badge>
            </template>

            <v-card width="800" v-if="display.size > 0">
                <v-container fluid>
                    {{ display.text }}
                </v-container>
            </v-card>
        </v-menu>
    </div>
</template>

<script>
import {usePaySlipAnnexStore} from "@/stores/PaySlipAnnex";
import {useDataSelectStore} from "@/stores/DataSelect";
import {useWorkerStore} from "@/stores/Worker/Worker";
import {useOrganizationalChartStore} from "@/stores/OrganizationalChart";
import {useOccupationStore} from "@/stores/Occupation";
import {useBankStore} from "@/stores/Bank";
import {useCategoryStore} from "@/stores/Category";
import useSharedMethod from "@/use/SharedMethod";
import useSharedSelectData from "@/use/SharedSelectData";
import {computed} from "vue";
import useTools from "@/use/Tools";
import {useContratTemplateStore} from "@/stores/ContratTemplate";
import {useControlProgramStore} from "@/views/Notification/stores/ControlProgram";
import {useWorkFlowStore} from "@/stores/Request/WorkFlow";
import {useCatalogStore} from "@/stores/Training/Catalog";
import {useTrainingPlanStore} from "@/stores/Training/TrainingPlan";
import {useSchoolStore} from "@/stores/Training/School";
import {useEvaluationFileStore} from "@/stores/Evaluation/EvaluationFile";
import {useControlIssueStore} from "@/views/Notification/stores/ControlIssue";
import {useCnasAgencyStore} from "@/stores/CnasAgency";

export default {
    name: "StrFilterButton",
    props: {
        filter: Object,
    },
    setup(props, {emit}) {
        const annexStore = usePaySlipAnnexStore();
        const dataSelectStore = useDataSelectStore();
        const workerStore = useWorkerStore();
        const organizationalChartStore = useOrganizationalChartStore();
        const occupationStore = useOccupationStore();
        const bankStore = useBankStore();
        const categoryStore = useCategoryStore();
        const contratTemplateStore = useContratTemplateStore();
        const controlProgramStore = useControlProgramStore();
        const controlIssueStore = useControlIssueStore();
        const workFlowStore = useWorkFlowStore();
        const catalogStore = useCatalogStore();
        const trainingPlanStore = useTrainingPlanStore();
        const schoolStore = useSchoolStore();
        const evaluationFileStore = useEvaluationFileStore();
        const cnasAgencyStore = useCnasAgencyStore();

        const {translateMonth, formatedDate} = useSharedMethod();
        const {
            workerPhases,
            transferModes,
            profiles,
            sex,
            paySlipPeriodicities,
            contratStatus,
            workFlowModules,
            restStates,
            validationWorkFlowStatus,
        } = useSharedSelectData();
        const {$i18n} = useTools();

        const display = computed(() => {
            let r = "";
            let size = 0;
            if (props.filter.month && !props.filter.periodicity) {
                r += ` + Mois: ${translateMonth(props.filter.month, true)}`;
                size++;
            }
            if (props.filter.code) {
                r += ` + Code: ${props.filter.code}`;
                size++;
            }
            if (props.filter.lastName) {
                r += ` + Nom: ${props.filter.lastName}`;
                size++;
            }
            if (props.filter.firstName) {
                r += ` + Prénom: ${props.filter.firstName}`;
                size++;
            }
            if (props.filter.name) {
                r += ` + Nom: ${props.filter.name}`;
                size++;
            }
            if (props.filter.lastState) {
                r += ` + Validation: ${props.filter.lastState}`;
                size++;
            }
            if (props.filter.annexId && !props.filter.periodicity) {
                let index = annexStore.paySlipAnnexes.findIndex(e => e.id === props.filter.annexId);
                r += ` + ${$i18n.t('common.month')}: ${annexStore.paySlipAnnexes[index].name}`;
                size++;
            }
            if (props.filter.closed !== null && props.filter.closed !== undefined) {
                if (props.filter.closed) {
                    r += " + Clôturé";
                } else {
                    r += " + Ouvert"
                }
                size++;
            }
            if (props.filter.tagId) {
                let index = dataSelectStore.dataSelectsSelect['PAY_SLIP_TAG'].findIndex(e => e.id === props.filter.tagId);
                r += ` + Tag: ${dataSelectStore.dataSelectsSelect['PAY_SLIP_TAG'][index].name}`;
                size++;
            }
            if (props.filter.transferMode) {
                let index = transferModes.findIndex(e => e.id === props.filter.transferMode);
                r += ` + Règlement: ${transferModes[index].name}`;
                size++;
            }
            if (props.filter.bankId) {
                let index = bankStore.banksSelect.findIndex(e => e.id === props.filter.bankId);
                r += ` + Banque Vierment: ${bankStore.banksSelect[index].name}`;
                size++;
            }
            if (props.filter.profile) {
                let index = profiles.findIndex(e => e.id === props.filter.profile);
                r += ` + Profile: ${profiles[index].name}`;
                size++;
            }
            if (props.filter.categoryId) {
                let index = categoryStore.categoriesSelect.findIndex(e => e.id === props.filter.categoryId);
                r += ` + Grille: ${categoryStore.categoriesSelect[index].fullName}`;
                size++;
            }
            if (props.filter.workerId) {
                let index = workerStore.workersSelect.findIndex(e => e.id === props.filter.workerId);
                r += ` + Employé: ${workerStore.workersSelect[index].name}`;
                size++;
            }
            if (props.filter.cnasAgencyId) {
                let index = cnasAgencyStore.cnasAgencies.findIndex(e => e.id === props.filter.cnasAgencyId);
                r += ` + Agence CNAS: ${cnasAgencyStore.cnasAgencies[index].name}`;
                size++;
            }
            if (props.filter.evaluatorId) {
                let index = workerStore.workersSelect.findIndex(e => e.id === props.filter.evaluatorId);
                r += ` + Evaluateur: ${workerStore.workersSelect[index].name}`;
                size++;
            }
            if (props.filter.evaluationFileId) {
                let index = evaluationFileStore.evaluationFiles.findIndex(e => e.id === props.filter.evaluationFileId);
                r += ` + Fiche Compétence: ${evaluationFileStore.evaluationFiles[index].name}`;
                size++;
            }
            if (props.filter.phase) {
                let index = workerPhases.findIndex(e => e.id === props.filter.phase);
                r += ` + ${workerPhases[index].name}`;
                size++;
            }
            if (props.filter.organizationalchartIds && props.filter.organizationalchartIds.length > 0) {
                const orgs = organizationalChartStore.organizationalChartsSelect.filter(obj => props.filter.organizationalchartIds.includes(obj.id));
                r += " + Organigramme:"
                orgs.forEach(org => r += ` ${org.name},`);
                size++;
            }
            if (props.filter.occupationId) {
                let index = occupationStore.occupationsSelect.findIndex(e => e.id === props.filter.occupationId);
                r += ` + Fonction: ${occupationStore.occupationsSelect[index].name}`;
                size++;
            }
            if (props.filter.departmentId) {
                let index = dataSelectStore.dataSelectsSelect['WORKER_DEPARTMENT'].findIndex(e => e.id === props.filter.departmentId);
                r += ` + Département: ${dataSelectStore.dataSelectsSelect['WORKER_DEPARTMENT'][index].name}`;
                size++;
            }
            if (props.filter.servizioId) {
                let index = dataSelectStore.dataSelectsSelect['WORKER_SERVICE'].findIndex(e => e.id === props.filter.servizioId);
                r += ` + Service: ${dataSelectStore.dataSelectsSelect['WORKER_SERVICE'][index].name}`;
                size++;
            }
            if (props.filter.teamId) {
                let index = dataSelectStore.dataSelectsSelect['WORKER_TEAM'].findIndex(e => e.id === props.filter.teamId);
                r += ` + Equipe: ${dataSelectStore.dataSelectsSelect['WORKER_TEAM'][index].name}`;
                size++;
            }
            if (props.filter.workplaceId) {
                let index = dataSelectStore.dataSelectsSelect['WORKER_WORKPLACE'].findIndex(e => e.id === props.filter.workplaceId);
                r += ` + Lieu de Travail: ${dataSelectStore.dataSelectsSelect['WORKER_WORKPLACE'][index].name}`;
                size++;
            }
            if (props.filter.companyId) {
                let index = dataSelectStore.dataSelectsSelect['WORKER_COMPANY'].findIndex(e => e.id === props.filter.companyId);
                r += ` + Société de déclaration: ${dataSelectStore.dataSelectsSelect['WORKER_COMPANY'][index].name}`;
                size++;
            }
            if (props.filter.stateId) {
                let index = dataSelectStore.dataSelectsSelect['WORKER_STATE'].findIndex(e => e.id === props.filter.stateId);
                r += ` + Etat: ${dataSelectStore.dataSelectsSelect['WORKER_STATE'][index].name}`;
                size++;
            }
            if (props.filter.sex) {
                let index = sex.findIndex(e => e.id === props.filter.sex);
                r += ` + Sex: ${sex[index].name}`;
                size++;
            }
            if (props.filter.periodicity) {
                let index = paySlipPeriodicities.findIndex(e => e.id === props.filter.periodicity);
                r += ` + Période: ${paySlipPeriodicities[index].name}`;
                size++;
            }

            if (props.filter.enterDateStart) {
                r += ` + Date récretement du: ${formatedDate(props.filter.enterDateStart)}`;
                size++;
            }

            if (props.filter.enterDateEnd) {
                r += ` + Date récretement au: ${formatedDate(props.filter.enterDateEnd)}`;
                size++;
            }

            if (props.filter.workFlowId) {
                let index = workFlowStore.workFlows.findIndex(e => e.id === props.filter.workFlowId);
                r += ` + Processus de Validation: ${workFlowStore.workFlows[index].name}`;
                size++;
            }

            if (props.filter.workFlowModules) {
                let index = workFlowModules.findIndex(e => e.id === props.filter.workFlowModules);
                r += ` + Module de Validation: ${workFlowModules[index].name}`;
                size++;
            }

            if (props.filter.start) {
                r += ` Du: ${formatedDate(props.filter.start)}`;
                size++;
            }

            if (props.filter.end) {
                r += ` Au: ${formatedDate(props.filter.end)}`;
                size++;
            }


            if (props.filter.startMonth) {
                r += ` Du: ${translateMonth(props.filter.startMonth, true)}`;
                size++;
            }

            if (props.filter.endMonth) {
                r += ` Au: ${formatedDate(props.filter.end, true)}`;
                size++;
            }

            if (props.filter.restState) {
                let index = restStates.findIndex(e => e.id === props.filter.restState);
                r += ` + ${$i18n.t('debts.refund_status')}: ${restStates[index].name}`;
                size++;
            }

            // worker balance
            if (props.filter.minYear && props.filter.maxYear) {
                r += ` + Période: ${props.filter.minYear} / ${props.filter.maxYear}`;
                size++;
            }

            if (props.filter.operation && props.filter.field && props.filter.value) {
                r += ' + ' + $i18n.t(`balance.${props.filter.field}`) + ' ' + $i18n.t(`operation.${props.filter.operation}`) + ' ' + props.filter.value
                size++;
            }

            // Contrat
            if (props.filter.number) {
                r += ` + ${$i18n.t('contrat.number')}: ${props.filter.number}`;
                size++;
            }

            if (props.filter.contratTemplateId) {
                let index = contratTemplateStore.contratTemplates.findIndex(e => e.id === props.filter.contratTemplateId);
                r += ` + ${$i18n.t('module.contrat_template')}: ${contratTemplateStore.contratTemplates[index].name}`;
                size++;
            }

            if (props.filter.status) {
                const states = contratStatus.filter(obj => props.filter.status.includes(obj.id));
                r += " + Etat Contrat:"
                states.forEach(state => r += ` ${state.name},`);
                size++;
            }

            if (props.filter.trialPeriodStatus) {
                r += ` + Période d'essai: ${$i18n.t(`contrat.trial_period_status.${props.filter.trialPeriodStatus}`)}`;
                size++;
            }

            if (props.filter.validationStatus) {
                const states = validationWorkFlowStatus.filter(obj => props.filter.validationStatus.includes(obj.id));
                r += " + Etat Demande:"
                states.forEach(state => r += ` ${state.name},`);
                size++;
            }

            if (props.filter.programIds && props.filter.programIds.length !== 0) {
                const programs = controlProgramStore.controlPrograms.filter(obj => props.filter.programIds.includes(obj.id));
                r += ` + ${$i18n.t('module.control_program')}:`;
                programs.forEach(program => r += ` ${program.name}`);
                size++;
            }

            if (props.filter.issueIds && props.filter.issueIds.length !== 0) {
                const issues = controlIssueStore.controlIssues.filter(obj => props.filter.issueIds.includes(obj.id));
                r += ` + ${$i18n.t('module.issue')}:`;
                issues.forEach(issue => r += ` ${issue.name}`);
                size++;
            }

            if (props.filter.determinedTime !== null && props.filter.determinedTime !== undefined) {
                if (props.filter.determinedTime) {
                    r += " + CDD";
                } else {
                    r += " + CDI"
                }
                size++;
            }

            if (props.filter.duration && props.filter.periodicity) {
                alert()
                r += ` + Durée: ${props.filter.duration} ${$i18n.t('common.' + props.filter.periodicity)}`;
                size++;
            }

            if (props.filter.trialPeriod !== null && props.filter.trialPeriod !== undefined) {
                if (props.filter.trialPeriod) {
                    r += " + Avec Période d'essai";
                } else {
                    r += " + Sans Période d'essai";
                }
                size++;
            }

            if (props.filter.natureId) {
                let index = dataSelectStore.dataSelectsSelect['CONTRAT_NATURE'].findIndex(e => e.id === props.filter.natureId);
                r += ` + ${$i18n.t('module.contrat_characteristic')}: ${dataSelectStore.dataSelectsSelect['CONTRAT_NATURE'][index].name}`;
                size++;
            }

            if (props.filter.terminated !== null && props.filter.terminated !== undefined) {
                if (props.filter.terminated) {
                    r += " + Fin Contrat";
                }
                size++;

                if (props.filter.leavingStart) {
                    r += ` Du: ${formatedDate(props.filter.leavingStart)}`;
                }

                if (props.filter.leavingStart) {
                    r += ` Au: ${formatedDate(props.filter.leavingEnd)}`;
                }

                if (props.filter.exitRationaleId) {
                    let index = dataSelectStore.dataSelectsSelect['CONTRAT_EXIT_RATIONALE'].findIndex(e => e.id === props.filter.exitRationaleId);
                    r += ` + ${$i18n.t('module.contrat_leaving_reasons')}: ${dataSelectStore.dataSelectsSelect['CONTRAT_EXIT_RATIONALE'][index].name}`;
                    size++;
                }
            }

            if (props.filter.catalogId) {
                let index = catalogStore.catalogs.findIndex(e => e.id === props.filter.catalogId);
                r += ` + ${$i18n.t('module.training_catalog')}: ${catalogStore.catalogs[index].name}`;
                size++;
            }

            if (props.filter.otherDescription) {
                r += ` + ${$i18n.t('training.other_catalog_description')}: ${props.filter.otherDescription}`;
                size++;
            }

            if (props.filter.period) {
                r += ` + ${$i18n.t('training.period')}: ${$i18n.t(`training.${props.filter.period}`)}`;
                size++;

                if (props.filter.periodMonth && props.filter.period === 'MONTHLY') {
                    r += ` + ${$i18n.t('common.month')}: ${$i18n.t(`common.${props.filter.periodMonth}`)}`;
                    size++;
                }

                if (props.filter.periodStart && props.filter.period === 'SPECIFIC') {
                    r += ` ${$i18n.t('common.from')}: ${formatedDate(props.filter.periodStart)}`;
                    size++;
                }

                if (props.filter.periodEnd && props.filter.period === 'SPECIFIC') {
                    r += ` ${$i18n.t('common.to')}: ${formatedDate(props.filter.periodEnd)}`;
                    size++;
                }

                if (props.filter.periodQuarterlyOrHalfYearly && props.filter.period === 'QUARTERLY') {
                    r += ` + ${$i18n.t('training.QUARTERLY')}: ${$i18n.t(`common.QUARTERLY${props.filter.periodQuarterlyOrHalfYearly}`)}`;
                    size++;
                }

                if (props.filter.periodQuarterlyOrHalfYearly && props.filter.period === 'HALF_YEARLY') {
                    r += ` + ${$i18n.t('training.HALF_YEARLY')}: ${$i18n.t(`common.HALF_YEARLY_${props.filter.periodQuarterlyOrHalfYearly}`)}`;
                    size++;
                }
            }

            if (props.filter.workerIds) {
                r += ` + ${$i18n.t('common.workers_number')}: ${props.filter.workerIds.length}`;
                size++;
            }

            if (props.filter.planId) {
                let index = trainingPlanStore.trainingPlans.findIndex(e => e.id === props.filter.planId);
                r += ` + ${$i18n.t('module.training_plan')}: ${trainingPlanStore.trainingPlans[index].name}`;
                size++;
            }

            if (props.filter.schoolId) {
                let index = schoolStore.schools.findIndex(e => e.id === props.filter.schoolId);
                r += ` + ${$i18n.t('module.training_school')}: ${schoolStore.schools[index].name}`;
                size++;
            }

            return {
                size: size,
                text: r,
            };
        });

        function click() {
            emit('press');
        }

        return {
            display,
            click
        }
    }
}
</script>

<style scoped>

</style>